// router.js

import { createRouter, createWebHashHistory } from 'vue-router';

// Importez vos composants de page ici
import Home from '../pages/Home';
import About from '../pages/Questions';
import QSN from '../pages/QSN';
import Services from "@/pages/Services";
/*import LogementDetails from "@/components/Logement/LogementDetails";*/
import Api from "@/components/Logement/Api";
import LogementInfos from "@/components/Logement/LogementInfos";
import Logements from "@/pages/Logements";
import MentionsLegales from "@/pages/MentionsLegales";
import Conditions from "@/pages/Conditions";
import Formulaire from "@/pages/Formulaire";
import Arrondissement from "@/pages/Arrondissement";
import ListingByArrondissement from "@/components/Logements/ListingByArrondissement";
import Proprietaire from "@/pages/Proprietaire";
import ListingByRoom from "@/components/Logements/ListingByRoom";
import LogementDetailsV2 from "@/components/Logement/LogementDetailsV2";

const routes = [
    {
        path: '/',
        component: Home,
    },
    {
        path: '/questions',
        component: About,
    },
    {
        path: '/qui-sommes-nous',
        component: QSN,
    },
    {
        path: '/services',
        component: Services,
    },
    {
        path: '/logements',
        component: Logements,
    },
    {
        path: '/logement/:id',
        name: 'logement-details',
        components: {
            default: LogementDetailsV2, // Composant par défaut pour /logement/:id
            api: Api, // Composant pour /logement/:id/api
            infos: LogementInfos, // Composant pour /logement/:id/infos
        },
        props: {
            default: true,
            api: true,
            infos: true,
        },
    },
    {
        path: '/mentionslegales',
        component: MentionsLegales,
    },
    {
        path: '/conditions',
        component: Conditions,
    },
    {
        path: '/contact',
        component: Formulaire,
    },
    {
        path: '/listingbyarrondissement',
        component: ListingByArrondissement,
    },
    {
        path: '/listingbyroom',
        component: ListingByRoom,
    },
    {
        path: '/proprietaire',
        component: Proprietaire,
    },
    {
        path: '/destinations/:id',
        name: 'destinations', // Assurez-vous que le nom de la route est correct
        component: Arrondissement,
        props: true,
    },

];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // Vérifiez si la route actuelle est la page spécifique
        const isPageSpecifique = to.name === 'logement-details';

        if (isPageSpecifique) {
            // Si c'est la page spécifique, vous pouvez ne pas utiliser le comportement par défaut
            return savedPosition || { behavior: 'auto' };
        } else {
            // Pour toutes les autres pages, utilisez le comportement par défaut
            return savedPosition || { behavior: 'smooth', top: 0 };
        }
    },
});


export default router;
